import { IAddress, IDisplayAddress, ICountryOrState } from 'base/interfaces/address';
import { getStoreState, useStoreState } from 'base/store'
import type { ICountry } from 'mod/store/locale/interface';

// 增加显示属性
export function getDisplayAddress(address: IAddress): IDisplayAddress {
    const address2 = address.address2 ? `, ${address.address2}` : '';
    return {
        ...address,
        name: `${address.firstName} ${address.lastName}`,
        street: address.address1 + address2,
        locale: `${address.cityText}, ${address.provinceText}, ${address.countryText}, ${address.zipcode}`
    }
}

// 默认地址显示在第一位，增加显示属性
export function getDisplayList(list: IAddress[]): IDisplayAddress[] {
    if (list.length === 0) {
        return [];
    }
    let defaultIndex: number = 0;
    const _list = list.map((item, index) => {
        if (item.isDefault) {
            defaultIndex = index;
        }
        return getDisplayAddress(item);
    });
    // 默认地址显示在第一个
    // if (defaultIndex > 0) {
    //     const defaultItem = _list.splice(defaultIndex, 1);
    //     _list.unshift(defaultItem[0]);
    // }
    return _list
}

// countryAndState 数组转换成对象格式
export const mapCountrisAndStates = (list: ICountryOrState[], obj: Record<number, ICountryOrState> = {}) => {
    list.forEach(item => {
        obj = {
            ...obj,
            [item.id]: item
        };
        if (item.children) {
            obj = mapCountrisAndStates(item.children, obj);
        }
    })
    return obj;
}

// country 数组转换成对象格式
export const mapCountries = (list: ICountryOrState[]): Record<number, ICountryOrState> => {
    const o: Record<number, ICountryOrState> = {};
    list.forEach(item => {
        o[item.id] = item;
    })
    return o;
}

/**
 * 返回当前国家
 */
export const getCurrentCountry = (): ICountry | undefined => {
    const { country: currentCountryCode } = getStoreState('rootStore')
    const { localeList } = getStoreState('persistStore')
    return localeList?.find(item => item.countryCode == currentCountryCode) // 当前选中的国家数据
}